export default "__VITE_ASSET__d4c13737__"